/**
 * Angular imports
 */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var SearchAutoSuggestService = /** @class */ (function () {
    function SearchAutoSuggestService(http) {
        this.http = http;
    }
    /**
     * Gets product lookup
     */
    SearchAutoSuggestService.prototype.getLookupDataFromApi = function (keySearchConfig, searchText) {
        var array = JSON.parse(keySearchConfig.filterConfiguration);
        // TODO: Type url params
        this.options = {
            apiEndpoint: keySearchConfig.apiEndpoint,
            configuration: keySearchConfig.configuration,
            filters: array,
        };
        this._filters = this.createFilters();
        var payload = {
            configuration: keySearchConfig.configuration,
            facets: this.getSelectedFacets(),
            offset: 0,
            isCallFromAutoSuggest: true,
            keywordForAutoSuggest: searchText,
            autoSuggestOffset: $('.js-download-table__counter-footer').attr("data-currentcount")
        };
        return this.http.post(keySearchConfig.apiEndpoint, { data: payload });
    };
    SearchAutoSuggestService.prototype.getSelectedFacets = function () {
        var results = [];
        for (var i = 0; i < this._filters.length; i++) {
            var filter = this._filters[i];
            var value = filter.$element.val();
            if (value) {
                results.push({ id: filter.id, value: value });
            }
        }
        return results;
    };
    SearchAutoSuggestService.prototype.createFilters = function () {
        var results = [];
        for (var i = 0; i < this.options.filters.length; i++) {
            var filter = this.options.filters[i];
            var element = document.getElementById(filter.id);
            if (element != null) {
                results.push({
                    $element: $(element),
                    id: filter.id
                });
            }
        }
        return results;
    };
    SearchAutoSuggestService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root',
                },] }
    ];
    /** @nocollapse */
    SearchAutoSuggestService.ctorParameters = function () { return [
        { type: HttpClient }
    ]; };
    SearchAutoSuggestService.ngInjectableDef = i0.defineInjectable({ factory: function SearchAutoSuggestService_Factory() { return new SearchAutoSuggestService(i0.inject(i1.HttpClient)); }, token: SearchAutoSuggestService, providedIn: "root" });
    return SearchAutoSuggestService;
}());
export { SearchAutoSuggestService };
//# sourceMappingURL=search-auto-suggest.service.js.map